import IconComponent from "icons/IconComponent";

import EditSmallIcon from "./editSmall.svg";

export default (EditSmallIcon as any) as IconComponent;
